var render = function render(){var _vm=this,_c=_vm._self._c;return _c('text-body-regular',{staticClass:"gc-card-text__header",attrs:{"weight":'extra-bold',"lineHeight":'multi'}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }